import React, { useState } from "react";
import { Edit, Trash2 } from "lucide-react";
import { sliderService } from "../../services/sliderService";
import DeleteConfirmation from "../common/DeleteConfirmation";
import { SliderForm } from "./SliderForm";
import { toast } from "react-toastify";

const SliderList = ({ sliders = [], categories = [], setSliders }) => {
  const [selectedSlider, setSelectedSlider] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleDeleteSlider = async () => {
    if (!selectedSlider?._id) return;

    try {
      await sliderService.deleteSlider(selectedSlider._id);
      setSliders((prev) =>
        prev.filter((slider) => slider._id !== selectedSlider._id)
      );
      setIsDeleteModalOpen(false);
      toast.success("Slider deleted successfully!");
    } catch (error) {
      console.error("Failed to delete slider:", error);
      toast.error("Failed to delete slider!");
    }
  };

  const handleEditSlider = async (formData) => {
    if (!selectedSlider?._id) return;

    try {
      const updatedSlider = await sliderService.updateSlider(
        selectedSlider._id,
        formData
      );
      if (updatedSlider) {
        setSliders((prev) =>
          prev.map((slider) =>
            slider._id === updatedSlider._id ? updatedSlider : slider
          )
        );
        setIsEditModalOpen(false);
        toast.success("Slider updated successfully!");
      }
    } catch (error) {
      console.error("Failed to update slider:", error);
      toast.error("Failed to update slider!");
    }
  };

  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      {sliders && sliders.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
          {sliders.map((slider) => (
            <div
              key={slider._id}
              className="border rounded-lg overflow-hidden hover:shadow-lg transition"
            >
              <img
                src={slider.image}
                alt={slider.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold mb-2">{slider.title}</h3>
                {slider.category && (
                  <p className="text-sm text-gray-500 mb-3">
                    Category: {slider.category}
                  </p>
                )}
                <div className="flex items-center justify-end space-x-3">
                  <button
                    onClick={() => {
                      setSelectedSlider(slider);
                      setIsEditModalOpen(true);
                    }}
                    className="text-blue-500 hover:text-blue-700"
                  >
                    <Edit size={20} />
                  </button>
                  <button
                    onClick={() => {
                      setSelectedSlider(slider);
                      setIsDeleteModalOpen(true);
                    }}
                    className="text-red-500 hover:text-red-700"
                  >
                    <Trash2 size={20} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center py-4">No sliders found</p>
      )}

      <DeleteConfirmation
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDeleteSlider}
        itemName="slider"
      />

      {selectedSlider && (
        <SliderForm
          isOpen={isEditModalOpen}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedSlider(null);
          }}
          onSubmit={handleEditSlider}
          initialData={selectedSlider}
          categories={categories}
        />
      )}
    </div>
  );
};

export default SliderList;